'use client';

import { signOut } from '@/lib/auth/client';

/**
 * The header prompt on an auth screen reached by somebody already signed in.
 *
 * The business picker is the case: it is served by `AuthShell`, whose header
 * otherwise offers "Need an account? Sign up" — nonsense to read when you have
 * just typed your password, and worse than nonsense on the "switch business"
 * route, where an existing user is being invited to open a second account.
 *
 * Signing out is the action that actually belongs there. It is also the only
 * escape from the picker: with no business selected the app has nowhere to
 * send you, so without this the only way out is the browser's back button.
 */
export default function SignOutPrompt() {
  return (
    <p className="text-sm text-muted">
      Not you?{' '}
      <button
        type="button"
        onClick={() => signOut()}
        className="link font-medium"
      >
        Sign out
      </button>
    </p>
  );
}
